/*! Meller Room — Shopify section bootstrap */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('meller-room-section')) return;
  class MellerRoomSection extends HTMLElement {
    connectedCallback() {
      if (this.room) return;
      var dataEl = this.querySelector('script[type="application/json"]');
      var mount = this.querySelector('.mr-mount');
      if (!dataEl || !mount || !window.MellerRoom || !window.MellerRoomScene) return;
      var content;
      try { content = JSON.parse(dataEl.textContent); } catch (e) { console.error('Meller Room: invalid JSON', e); return; }
      var base = this.dataset.assetBase || '';
      // fill the screen below whatever sits above the room (announcement bar, header)
      this._setTop = function () {
        var top = mount.getBoundingClientRect().top + window.scrollY;
        mount.style.setProperty('--mr-top', Math.max(0, Math.round(top)) + 'px');
      };
      this._setTop();
      window.addEventListener('resize', this._setTop);
      this.room = new window.MellerRoom(mount, {
        scene: window.MellerRoomScene,
        content: content,
        strings: content.strings,
        resolve: function (name) { return base + 'meller-' + name; },
        // the store's chat launcher sits over the pop-up's corner: hide it while one is open
        onOpen: function () { document.documentElement.classList.add('mr-popup-open'); },
        onClose: function () { document.documentElement.classList.remove('mr-popup-open'); }
      });
    }
    disconnectedCallback() {
      if (this._setTop) window.removeEventListener('resize', this._setTop);
      if (this.room) this.room.destroy();
      document.documentElement.classList.remove('mr-popup-open');
      this.room = null;
    }
  }
  customElements.define('meller-room-section', MellerRoomSection);
})();
